export default __webpack_public_path__ + "static/media/signal_offline.4099028a.svg";